export const ApiConfig = {
    token: '',
    headers: new Headers({
        'Accept': 'application/json'
    }),
    baseURL: `${baseHref}`, // eslint-disable-line
}